import React from 'react';
import IReplacementRange from '../../types/ReplacementRange';

interface DraftRowProps {
  draftRange: IReplacementRange;
  'aria-rowindex'?: number;
}

/**
 * Individual draft row component following SRP
 * Clear naming conventions and accessibility compliance
 */
const DraftRow: React.FC<DraftRowProps> = ({ 
  draftRange, 
  'aria-rowindex': ariaRowIndex
}) => {
  /**
   * Formats flight draftRange as "flightRangeStart - end"
   * Low complexity utility function
   */
  const formatDraft = (flightRangeStart: number, end: number): string => 
    `${flightRangeStart} - ${end}`;

  /**
   * Returns discontinued date in YYYY-MM-DD format or empty string for active draftRanges
   */
  const getDiscontinuedStatus = (): string => {
    if (!draftRange.discontinueDate) return '';
    return draftRange.discontinueDate; // Already in YYYY-MM-DD format
  };

  return (
    <tr 
      role="row"
      className="draft-row"
      aria-rowindex={ariaRowIndex}
    >
      <td>
        <span className="text-font">
          {draftRange.id === '0' ? 'Replacement' : 'Existing'}
        </span>
      </td>
      <td>
        <span className="text-font">
          {draftRange.marketingCarrier}
        </span>
      </td>
      <td>
        <span className="text-font">
          {formatDraft(draftRange.start, draftRange.end)}
        </span>
      </td>
      <td>
        <span className="text-font">
          {draftRange.operatingCarrier}
        </span>
      </td>
      <td>
        <span className="text-font">
          {draftRange.flightTypeDescription}
        </span>
      </td>
      <td>
        <span className="text-success">
          {draftRange.effectiveDate || 'N/A'}
        </span>
      </td>
      <td>
        <span className="text-danger">
          {getDiscontinuedStatus()}
        </span>
      </td>
    </tr>
  );
};

export default DraftRow;